import { BoxProps, ButtonProps, TextNewProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../utils'

const DefaultStyles = {
  CalendarListContainer: {
    flex: 1,
  } as BoxProps,
  calendarItemStyle: { alignItems: 'center' } as BoxProps,
  arrowsView: {
    paddingHorizontal: 16,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    top: 0,
  } as BoxProps,
  arrowContainer: { borderColor: 'DISABLED_GREY', borderWidth: 1, borderRadius: 4, padding: 4 } as BoxProps,
  btnsContainer: {
    flexDirection: 'row',
    padding: 16,
  } as BoxProps,
  cancelBtnView: { paddingHorizontal: 8 } as BoxProps,
  MonthTitleStyle: {
    color: 'BLACK',
    marginTop: 4,
    fontSize: 14,
    fontWeight: 'BOLD',
  } as TextNewProps,
  DateListContainer: {} as ViewStyle,
  DateContainer: {
    alignItems: 'center',
    // flex: 1,
    padding: 2,
  } as BoxProps,
  WeekDayContainer: {
    flexDirection: 'row',
    justify: 'space-between',
    height: 30,
    f: 1,
    marginTop: 8,
    w: '90%',
  } as BoxProps,
  WeekDayTextContainer: {
    justifyContent: 'center',
    alignItems: 'stretch',
    flex: 1,
  } as ViewStyle,
  WeekDayTextStyle: {
    paddingHorizontal: 6,
    color: 'PRIMARY_GREY',
    fontWeight: '500',
    fontSize: 12,
  } as TextNewProps,
  CalendarContainer: {
    backgroundColor: Colors.WHITE,
    flex: 1,
  } as ViewStyle,
  CalendarListStyle: {
    width: '100%',
    paddingHorizontal: 6,
  } as ViewStyle,
  BottomBarContainer: {
    borderTopWidth: 1,
    borderColor: Colors.GREY_SEPARATOR,
    alignContent: 'flex-start',
  } as ViewStyle,
  LegendContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 4,
  } as ViewStyle,
  HolidayLegendIcon: {
    height: 8,
    width: 8,
    borderRadius: 4,
    backgroundColor: Colors.ERROR,
    marginRight: 8,
  } as ViewStyle,
  HolidayLegendTextStyle: {
    fontSize: 11,
    color: Colors.PRIMARY_GREY,
  } as ViewStyle,
  buttonType: {
    default: {
      color: 'TRANSPARENT',
      textType: 'body12',
      titleColor: 'BRAND_PRIMARY_BLACK',
      width: 30,
      height: 30,
      hoverColor: 'BLUE',
      borderRadius: 4,
      borderColor: 'TRANSPARENT',
      borderWidth: 1,
    } as ButtonProps,
    disabled: {
      disabled: true,
      titleColor: 'BRAND_COLOR_GRAY_2',
    } as ButtonProps,
    enabled: {} as ButtonProps,
    selected: {
      borderWidth: 1,
    } as ButtonProps,
    preselected: {
      borderRadius: 4,
      borderWidth: 1,
      borderColor: 'PRIMARY',
    } as ButtonProps,
  },
}

const styles = {
  Single: { ...DefaultStyles },
  Range: { ...DefaultStyles },
  History: { ...DefaultStyles },
  SINGLE_FUTURE: { ...DefaultStyles },
}

export default styles
